/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {BaseComponent, ToastModule} from "@intuitionrobotics/thunderstorm/frontend";
import {CarePlanConfig} from "./_to_be_modified/CarePlanConfig";
import {OnCareConfigQueryReturned} from "@modules/GoalsConfigModule";
import {Loader} from "../../widgets/Loader";
import {hideTooltip} from "./widget/appTooltip";
import {DB_Patient} from "@app/app-shared/patient";
import {PatientProvider} from "./PatientProvider";

export const Page_CarePlan = () => <PatientProvider>{p => <CarePlan patient={p}/>}</PatientProvider>

type Props = {
    patient: DB_Patient
};

class CarePlan
    extends BaseComponent<Props>
    implements OnCareConfigQueryReturned {

    __onCareConfigQueryReturned() {
        this.forceUpdate();
    }

    componentWillUnmount() {
        this.logDebug(`Page_CarePlan will unmount`);
        ToastModule.hideToast();
        hideTooltip();
    }

    render() {
        const patient = this.props.patient
        if (!patient)
            return <Loader/>;

        return <CarePlanConfig selectedPatient={patient}/>;
    }
}
